var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGestioneCampagne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 32L64 0 0 0 0 32l0 96L0 416l0 32 32 0 224 0 0-64L64 384l0-224 192 0 0-64L64 96l0-64zM288 224l288 0 0-192L432 32 400 0 288 0l0 224zm0 288l288 0 0-192-144 0-32-32-112 0 0 224z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGestioneCampagne);
export default __webpack_public_path__ + "static/media/gestione_campagne.e1a756a6fe70e35dd256216f80d50566.svg";
export { ForwardRef as ReactComponent };